import React, { useEffect, useState, useRef, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IonRouterOutlet, IonSplitPane, IonAlert } from '@ionic/react';
import { Redirect, Switch, useLocation, Route, useHistory } from 'react-router-dom';
import { Plugins } from '@capacitor/core';

// Pages
import { HomePage, HistoryPage, DetailPage, QrScanPage, ContactPage, DocumentPage, BenefitPage } from '../pages/virtual-card';

// Constants
import { APP_CONFIG } from '../constants';

// Components
import { MenuComponent, PermissionMessageComponent, MobileMaintenanceMessageComponent, MessageComponent, NetworkMessageComponent } from '../components';

// Guards
import { AuthGuard } from '../guards';

// Helpers
import { getUrlInitByPlatform, hasAccess, checkStateApp, saveVersion, redirectStore, isWeb, isBranchEnabled, extractConfigPage, closeAppInPagePrivate, loadModal, loadPageInit, clearModal } from '../helpers';

// Actions
import { resetStateAction, logout, startGetSettingAction } from '../redux';

// Validators
import { AppValidator } from './../validators';

// Contexts
import { AppContext } from '../contexts';

// Se debe hacer global para evitar perder la referencia al menu
let menuRef = {};

export const PrivateRoute = () => {

    const { network } = useContext(AppContext);
    menuRef = useRef({});
    const history = useHistory();
    const location = useLocation();
    const dispatch = useDispatch();
    const { user } = useSelector(state => state.auth);
    const { gonogo } = useSelector(state => state.app);
    const [showModal, setShowModal] = useState({ show: false, title: '', message: '' });
    const [showModalNetwork, setShowModalNetwork] = useState({ show: false, title: APP_CONFIG.PAGES.OFFLINE.title, message: APP_CONFIG.PAGES.OFFLINE.message });
    const { App: AppScanClub } = Plugins;

    const { metadata } = user;
    const { accountName } = metadata;

    useEffect(() => {

        if (network.connected !== undefined) {

            setShowModalNetwork({
                ...showModalNetwork,
                show: !network.connected
            });

            if (!network.connected) {

                history.push(APP_CONFIG.PAGES.OFFLINE.path);
            }
        }

    }, [network.connected]);

    /**
     * Controla la redicción en caso que no aplique refresh token
     * Al momento de expirar la sesión, redirige al login
     */
    useEffect(() => {

        const authGuard = new AuthGuard(APP_CONFIG.GUARDS.AUTH.TIME_START, APP_CONFIG.GUARDS.AUTH.TIME_INTERVAL);
        authGuard.init(() => {

            dispatch(logout());
        });

        return () => {

            return authGuard.end();
        }

    }, []);

    /**
     * Pongo a escuchar eventos de la app
     */
    useEffect(() => {

        AppScanClub.addListener('appStateChange', (state) => {

            if (state.isActive) {

                if (APP_CONFIG.VERSION !== undefined && APP_CONFIG.VERSION.currentVersion !== '') {

                    saveVersion(APP_CONFIG.VERSION.currentVersion);
                }

                dispatch(startGetSettingAction());
            }

        });

        AppScanClub.addListener('backButton', (data) => {

            // Si era la página de detalle o de contacto y se abrió el modal
            if ((window.location.pathname === APP_CONFIG.PAGES.DETAIL.path || window.location.pathname === APP_CONFIG.PAGES.CONTACT.path)
                && loadModal()) {

                clearModal();
                const pathRedirect = loadPageInit();
                window.location.search = pathRedirect;
            }
            else if (closeAppInPagePrivate(window.location.pathname)) {

                AppScanClub.exitApp();
            }
        });

        return () => {

            AppScanClub.removeAllListeners();
        };

    }, []);

    /**
     * Cada vez que se modifique el gonogo, va a chequear el estado de la app
     */
    useEffect(() => {

        checkStateApp(setShowModal, history);
        const pageConfig = extractConfigPage(location);
        if (APP_CONFIG.PAGES.OFFLINE.path === pageConfig.path) {

            history.replace(getUrlInitByPlatform(user.permissions, network));
            return;
        }

        // Pregunto que sea distinto a Contact, porque cuando el usuario selecciona Menú Contacto, renderiza la opción de menú,
        // seteando el path a contact, pero luego se renderiza este useEffect, y lo pasa a notAuthorized
        if (!isBranchEnabled() && history.location.pathname !== APP_CONFIG.PAGES.CONTACT.path) {

            history.replace(APP_CONFIG.PAGES.NOT_AUTHORIZED.path);
            return;
        }

        const mainteinment = AppValidator.AppIsMainteinment();

        // Si no está autorizado para ingresar a la página actual
        // const pageConfig = extractConfigPage(location);
        if (APP_CONFIG.PAGES.NOT_AUTHORIZED.path !== pageConfig.path &&
            APP_CONFIG.PAGES.MAINTEINMENT.path !== pageConfig.path &&
            APP_CONFIG.PAGES.LOGIN.path !== pageConfig.path &&
            !hasAccess(pageConfig.permissions, user.permissions)) {

            history.replace(APP_CONFIG.PAGES.NOT_AUTHORIZED.path);
        }
        else if (!mainteinment.enabled &&
            (APP_CONFIG.PAGES.DOCUMENT.path === pageConfig.path ||
                APP_CONFIG.PAGES.QR_SCAN.path === pageConfig.path ||
                APP_CONFIG.PAGES.NOT_AUTHORIZED.path === pageConfig.path)) {

            history.replace(getUrlInitByPlatform(user.permissions, network));
        }

    }, [gonogo]);

    /**
     * Obtiene el componente para la Web que se mostrará en caso de mantenimiento
     */
    const getMainteinment = () => {

        if (isWeb()) {

            return (
                <>
                    <MessageComponent
                        message={APP_CONFIG.MESSAGE.ALERT.mainteinment.message}
                        urlImage="assets/images/maintenance.svg"
                    >
                    </MessageComponent>
                </>);
        }

        return null;
    };

    /**
     * Obtiene el componente que se mostrará en caso de no tener autorización
     */
    const getNotAuthorized = () => {

        return (
            <>
                <PermissionMessageComponent
                    title={APP_CONFIG.MESSAGE.INFO.permissions.title}
                    message={APP_CONFIG.MESSAGE.INFO.permissions.message}
                >
                </PermissionMessageComponent>
            </>);
    };

    /**
     * Resuelve el Route para la página NotAuthorized
     */
    const getNotAuthorizedRoute = () => {

        if (history.location.pathname === APP_CONFIG.PAGES.NOT_AUTHORIZED.path) {

            return getNotAuthorized();
        }

        return null;
    };

    const getTitleMenu = () => {

        let title = `${accountName}`;
        return title;
    };

    return (

        <>
            {/* MOBILE - MODAL MAINTEINTMENT*/}
            {showModal.show && !isWeb() &&

                <MobileMaintenanceMessageComponent
                    showModal={showModal}
                />
            }

            <IonSplitPane when="lg" contentId={APP_CONFIG.CONTENT_ID}>

                <MenuComponent
                    menuId={APP_CONFIG.MENU_ID}
                    contentId={APP_CONFIG.CONTENT_ID}
                    title={accountName && getTitleMenu()}
                    setInit={() => {

                        dispatch(resetStateAction());
                    }}
                    logout={() => {

                        dispatch(logout());
                    }}
                    permissions={user.permissions}
                    menuRef={menuRef}
                >
                </MenuComponent>

                <IonRouterOutlet id={APP_CONFIG.CONTENT_ID}>

                    <Switch>
                        <Route
                            path={APP_CONFIG.PAGES.HOME.path}
                            component={
                                hasAccess(APP_CONFIG.PAGES.HOME.permissions, user.permissions) && isBranchEnabled() ?
                                    () => <HomePage menuRef={menuRef} userPermission={user.permissions} title={accountName && getTitleMenu()} /> : () => getNotAuthorized()
                            }
                            exact={true}
                        />
                        <Route
                            path={APP_CONFIG.PAGES.QR_SCAN.path}
                            component={
                                hasAccess(APP_CONFIG.PAGES.QR_SCAN.permissions, user.permissions) && isBranchEnabled() ?
                                    () => <QrScanPage menuRef={menuRef} userPermission={user.permissions} /> : () => getNotAuthorized()
                            }
                            exact={true}
                        />
                        <Route
                            path={APP_CONFIG.PAGES.DOCUMENT.path}
                            component={
                                hasAccess(APP_CONFIG.PAGES.DOCUMENT.permissions, user.permissions) && isBranchEnabled() ?
                                    () => <DocumentPage menuRef={menuRef} userPermission={user.permissions} /> : () => getNotAuthorized()
                            }
                            exact={true}
                        />
                        <Route
                            path={APP_CONFIG.PAGES.BENEFIT.path}
                            component={
                                hasAccess(APP_CONFIG.PAGES.BENEFIT.permissions, user.permissions) && isBranchEnabled() ?
                                    BenefitPage : () => getNotAuthorized()
                            }
                            exact={true}
                        />
                        <Route
                            path={APP_CONFIG.PAGES.DETAIL.path}
                            component={
                                hasAccess(APP_CONFIG.PAGES.DETAIL.permissions, user.permissions) && isBranchEnabled() ?
                                    DetailPage : () => getNotAuthorized()
                            }
                            exact={true}
                        />
                        <Route
                            path={APP_CONFIG.PAGES.HISTORY.path}
                            component={
                                hasAccess(APP_CONFIG.PAGES.HISTORY.permissions, user.permissions) && isBranchEnabled() ?
                                    HistoryPage : () => getNotAuthorized()
                            }
                            exact={true}
                        />
                        <Route
                            path={APP_CONFIG.PAGES.CONTACT.path}
                            component={
                                hasAccess(APP_CONFIG.PAGES.CONTACT.permissions, user.permissions) ?
                                    ContactPage : () => getNotAuthorized()
                            }
                            exact={true}
                        />

                        <Route
                            path={APP_CONFIG.PAGES.MAINTEINMENT.path}
                            component={() => getMainteinment()}
                            exact={true}
                        />

                        <Route
                            path={APP_CONFIG.PAGES.NOT_AUTHORIZED.path}
                            component={() => getNotAuthorizedRoute()}
                            exact={true}
                        />
                        <Redirect to={getUrlInitByPlatform(user.permissions, network)} />

                    </Switch>

                </IonRouterOutlet>

            </IonSplitPane>
        </>
    )
}
